import request from '@/config/axios'

// 媒体资源 VO
export interface MediaVO {
  id: string | number
  shopId: string | number
  spuId: string | number
  mediaType: string
  title: string
  url: string
  category: string
  sort: number
  isCover: boolean
  createTime: Date
}

// 获取媒体资源分页
export function getMediaPage(params: any) {
  return request.get({ url: '/hotel/media/page', params })
}

// 获取媒体资源详情
export function getMedia(id: string | number) {
  return request.get({ url: '/hotel/media/get?id=' + id })
}

// 创建媒体资源
export function createMedia(data: MediaVO) {
  return request.post({ url: '/hotel/media/create', data })
}

// 更新媒体资源
export function updateMedia(data: MediaVO) {
  return request.put({ url: '/hotel/media/update', data })
}

// 删除媒体资源
export function deleteMedia(id: string | number) {
  return request.delete({ url: '/hotel/media/delete?id=' + id })
}

// 更新排序
export function updateSort(data: any) {
  return request.put({ url: '/hotel/media/update-sort', data })
}
